import React, {useEffect, useState} from 'react';
import {labels} from '../../../../util/utils';
import Button from '../../BaseComponentWrappers/MotifButton';
import styled from 'styled-components';
import EntitiesModalWrapper from '../../EntityCrud/EntitiesModalWrapper';
import {clientSideEventNames, Entity} from '../../../../util/uiconstants';
import {getRisks, deleteRisk} from '../../../../actions/Risk/riskactions';
import {useDispatch, useSelector} from 'react-redux';
import {useEngagementId} from '../../../../util/customHooks';

export default function ManageRisks(props) {
	const {onClose, className} = props;
	const [showRisksModal, setShowRisksModal] = useState(false);
	const engagementId = useEngagementId();
	const [formattedRisks, setFormattedRisks] = useState([]);
	const risks = useSelector((store) => store.risks);
	const dispatch = useDispatch();

	const handlerOnModalOpen = () => {
		setShowRisksModal(true);
	};

	const handlerOnModalClose = () => {
		dispatch(getRisks(engagementId, {pageSize: -1, orderBy: 'RiskName' , orderByAscending: true}, {isManageRisks: true}));
		setShowRisksModal(false);
		window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
		onClose && onClose();
	};

	useEffect(() => {
		if (risks && risks?.data) {
			let formattedRisks = [];
			risks.data.map((risk) => {
				formattedRisks.push({id: risk.id, name: risk.riskName});
			});
			setFormattedRisks(formattedRisks);
		}
	}, [risks]);

	return (
		<StyledManageRisk className={`StyledManageRisk${className ? ' ' + className : ''}`}>
			<Button
				variant="text-alt"
				className="manageAccount"
				onClick={handlerOnModalOpen}
				showLabel
				isEllipsed
				buttonLabel={labels.manageRisk}
				noOfLines={1}
			/>
			{showRisksModal && (
				<EntitiesModalWrapper
					isManageEntities
					engagementId={engagementId}
					show={showRisksModal}
					entityType={Entity.Risk}
					setShow={setShowRisksModal}
					getAllAction={() => {
						return getRisks(engagementId, {pageSize: -1, orderBy: 'RiskName' , orderByAscending: true});
					}}
					entities={formattedRisks}
					deleteAction={(id) => {
						return deleteRisk(engagementId, id, {isManageRisks: true});
					}}
					onClose={handlerOnModalClose}
				/>
			)}
		</StyledManageRisk>
	);
}

const StyledManageRisk = styled.section`
	display: flex;
	justify-content: flex-end;
	padding-bottom: var(--spacing-small);
`;
